import React from 'react';
import { useT } from '../../../i18n';
import bullVsBearBanner from './assets/bull-vs-bear-banner.webp';

const HeroBanner = () => {
  const t = useT();
  return (
    <div className="relative w-full overflow-hidden rounded-[32px] border border-white/10">
      <img
        src={bullVsBearBanner}
        alt=""
        aria-hidden="true"
        // shorter on large screens so the live round is visible without scrolling
        className="aspect-[12/5] h-full w-full object-cover object-[center_30%] lg:aspect-[5/1]"
      />
      <div
        aria-hidden="true"
        className="absolute inset-0 bg-gradient-to-r from-black via-black/65 to-transparent"
      />
      <div
        aria-hidden="true"
        className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-transparent"
      />

      <div className="absolute inset-0 flex items-end p-5 sm:p-8">
        <div className="max-w-xl">
          <span className="lb-chip lb-chip-live">
            <span className="lb-dot" aria-hidden="true" />
            {t('bvb.liveRounds')}
          </span>
          <h1 className="lb-heading mt-3 text-3xl sm:text-4xl lg:text-5xl">
            Bull <span className="lb-gradient-text">vs</span> Bear
          </h1>
          <p className="mt-2 max-w-lg text-sm text-white/70 sm:text-base">
            {t('bvb.heroBody')}
          </p>
        </div>
      </div>
    </div>
  );
};

export default HeroBanner;
